export function AnomalyDashboardPage() {
  return <span>Anomaly Dashboard (coming soon...)</span>;
}

AnomalyDashboardPage.displayName = 'AnomalyDashboardPage';
